import { Component, OnInit} from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import 'rxjs/add/operator/filter';
import { GoalsService } from "src/app/_services/goals/goals.service"
import { LocalStorageService } from "src/app/_services/localStorage/local-storage.service";
import { AllocationService } from 'src/app/_services/resource-allocation/allocation.service';
import * as _ from 'lodash';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { ActionItemsGridRowRendererComponent } from '../../../../_shared/action-items-grid-row-renderer/action-items-grid-row-renderer.component';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from "@angular/material/snack-bar";
import { UserService } from 'src/app/_services/user/user.service';

@Component({
  selector: 'app-goal-hrpage',
  templateUrl: './goal-hrpage.component.html',
  styleUrls: ['./goal-hrpage.component.scss']
})
export class GoalHrpageComponent implements OnInit {
  defTempForm
  performancegoalsForm
  form: FormGroup;
  filterForm: FormGroup;
    // row data and column definitions  
    rowData: any;
    public columnDefs: ColDef[]; 
    modeAction:number = 1 //1 - create // 2 - update
    // gridApi and columnApi  
    private api: GridApi;  
    private columnApi: ColumnApi;  
    defaultColDef:any;
    rowSelection:any
    tenantId: string;
    userDetails: any;
    dataSource_performancegoals: any;
    gridLength = 0;
    sampleGridFrameworkComponents: any;
    selectedCheckboxData = [];
    deleteConfirmationMsg = 'Are you sure you want to delete';
    userDropdownList = [];
    getUserName: any;
    currentUser: any;
    goalsArray: any[] = [];
    goalsResponse : any[] = [];
    selectedUserId: any;
    selectedYear: any;
    headerValue: any;
    currentUserName: any;

  constructor(
    private storageService: LocalStorageService,
    private formBuilder: FormBuilder,
    private allocationService: AllocationService,
    private goalsService: GoalsService,
    private router: Router,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private userService: UserService,
  ) { 

    this.route.queryParams.subscribe(params => {
      this.selectedUserId = params['userId'];
      this.selectedYear = params['year']
    });

    this.defaultColDef = {
      flex: 1,
      minWidth: 100,
      resizable: true,
      wrapText: true,
      autoHeight: true,
    };
  this.rowSelection = 'multiple';
  this.columnDefs = this.createColumnDefs(); 

  this.sampleGridFrameworkComponents = {
    actionRowRendererComponent: ActionItemsGridRowRendererComponent
  };

  this.form = this.formBuilder.group({
    file: ['', Validators.required]
  });
  
  this.defTempForm = this.formBuilder.group({
    designation: new FormControl(''),
    year: new FormControl(''),
    userId: new FormControl(''),
  });

  this.filterForm = this.formBuilder.group({
    userId: new FormControl(''),
    year: new FormControl('')
  });

  this.performancegoalsForm = this.formBuilder.group({
    title: new FormControl('', Validators.required),
    status: new FormControl('', Validators.required),
    weightage: new FormControl('', Validators.required),
    deadline: new FormControl('', Validators.required),
    description: new FormControl(''),
    comment: new FormControl(''),
    userId: new FormControl(''),
    userName: new FormControl(''),
    startDate: new FormControl('', Validators.required),
    endDate: new FormControl(''),
    createdByUserId: new FormControl(''),
    createdByUserName: new FormControl(''),
    year: new FormControl(''),
    kra: new FormControl(''),
    kpi: new FormControl(''),
    midYearReview: new FormControl(''),
    endYearReview: new FormControl(''),
    employeeScore: new FormControl(''),
    ratingByManager: new FormControl(''),
    managerRatingScore: new FormControl(''),
    base: new FormControl(''),
    target: new FormControl(''),
    employeeMidYearReview: new FormControl(''),
    employeeEndYearReview: new FormControl(''),
    behavioral: new FormControl(''),
    weightageBoolean: new FormControl(''),
    baseBoolean: new FormControl(''),
    targetBoolean: new FormControl('')
  });

  }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));
    this.getUserList();
    this.getAllperformanceReportForAllUsers();

  }

  // getter for easy access to form fields
  get f() {
    return this.performancegoalsForm.controls;
  }

  getAllperformanceReportForAllUsers() {  
    this.goalsService.getAllperformanceReportForAllUsers().subscribe((response: any) => {
      this.rowData = response;
      console.log("rowData",this.rowData);
      // this.goalsResponse = response;
    })
  }

  // one grid initialisation, grap the APIs and auto resize the columns to fit the available space  
  onGridReady(params): void {
    this.api = params.api;
    this.columnApi = params.columnApi;
    this.api.sizeColumnsToFit();
  }

  isFirstColumn(params) {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    const thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  }

  onSelectionChanged(event) {
    this.selectedCheckboxData = []
    let select = event.api.getSelectedNodes();
    for (let item of select) {
      this.selectedCheckboxData.push(item.data)
    }
  }

    // create column definitions  
    private createColumnDefs() {
      return [
        {
          headerName: 'Employee Name',
          // filter: 'user',
          editable: false,
          sortable: true,
          headerCheckboxSelection: this.isFirstColumn,
          checkboxSelection: this.isFirstColumn,
          valueGetter: function(params) {
            return params.data.user;
          },
        },
        {
          headerName: 'Year',
          // field: 'year',
          filter: true,
          editable: false,
          sortable: true,
          valueGetter: function(params) {
            return params.data.report.technical.year;
          },
        },
        {
          headerName: 'Tecniqual Rating By Manager',
          // field: 'averageManagerRatingScore',
          filter: true,
          editable: false,
          sortable: true,
          valueGetter: function(params) {
            return params.data.report.technical.performanceRating;
          },
        },
        {
          headerName: 'Tecniqual Manager Rating Score',
          // field: 'managerRatingScore',
          filter: true,
          editable: false,
          sortable: true,
          valueGetter: function(params) {
            return params.data.report.technical.averageManagerRatingScore;
          },
        },
        {
          headerName: 'Behaviour Rating By Manager',
          // field: 'ratingByManager',
          filter: true,
          editable: false,
          sortable: true,
          valueGetter: function(params) {
            return params.data.report.behavioral.performanceRating;
          },
        },
        {
          headerName: 'Behaviour Manager Rating Score',
          // field: 'managerRatingScore',
          filter: true,
          editable: false,
          sortable: true,
          valueGetter: function(params) {
            return params.data.report.behavioral.averageManagerRatingScore;
          },
        },
      ] }

      getUserList() {
        this.userDropdownList = [];
        this.allocationService.getUserDetails().subscribe((response) => {
          this.getUserName = response;
          for (let item of response) {
            this.userDropdownList.push(
              `${item.id} . ${item.firstName} ${item.lastName}`
            );
          }
        });
      }

      createHyperLink(params): any {
        if (!params.data) { return; }
        const spanElement = document.createElement('span');
        spanElement.innerHTML = `<a href="${params.value}" > ${params.value} </a> `;
        let id = params.value.split(' . ')[0];
        let year = params.value.split(' - ')[1];
        spanElement.addEventListener('click', ($event) => {
          $event.preventDefault();
          // The below code is used to navigate from one page to another page in angular. you can change it
          // according to your requirement.
          this.router.navigate([this.tenantId + '/dashboard/hr/goal-profile-hr/goals-objective'], {queryParams: { userId: id, year: year}});
        });
        return spanElement;
      }

      getPerformanceReport(){
        this.goalsArray = [];
        let userId = parseInt(this.filterForm.get('userId').value.split(' . ')[0]);
        let year = this.filterForm.get('year').value;
        if(userId && year){
          this.goalsArray = this.goalsResponse.filter(item => (item.userId === userId && item.year === year));
          this.rowData = this.goalsArray;
        }
        else{
          this.snackBar.open('Please select Employee Name and/or Year!', 'Close', { duration: 3000 });
        }
      }

      // getGoalsForHrReview(){
      //   this.router.navigate([this.tenantId + '/dashboard/hr/goal-profile-hr/goal-hrpage'], {queryParams: { userId: this.selectedUserId, year: this.selectedYear}});
      // }

      // getGoalsForEndReview(){
      //   this.router.navigate([this.tenantId + '/dashboard/hr/goal-profile-hr/goal-endreview'], {queryParams: { userId: this.selectedUserId, year: this.selectedYear}});
      // }

      // viewAllObjectives(){
      //   this.goalsService.getPerformanceReportByUserId(this.selectedUserId, this.selectedYear).subscribe((response: any) => {
      //     this.rowData = response.goals;
      //   })
      // }

      // getGoalsForMidReview(){
      //   this.router.navigate([this.tenantId + '/dashboard/hr/goal-profile-hr/goal-midreview'], {queryParams: { userId: this.selectedUserId, year: this.selectedYear}});
      // }

      backToGoalProfile(){
        this.router.navigate([this.tenantId + '/dashboard/hr/goal-profile-hr/goal-profile']);
      }
}
